/**
 * Phase ID — Identity OS API client
 */

import axios from "axios";
import { getApiBaseUrl } from "@/lib/api-base";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";

const API = getApiBaseUrl();

function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchIdentityConfig() {
  const res = await axios.get(`${API}/identity/config`);
  return res.data;
}

export async function requestPasswordReset(email) {
  const res = await axios.post(
    `${API}/auth/request-reset`,
    { email: email.trim().toLowerCase() },
    withSkipGlobalError()
  );
  return res.data;
}

export async function registerAccount({
  email,
  password,
  name,
  role = "user",
  preferred_language = "en",
  turnstile_token,
}) {
  const res = await axios.post(
    `${API}/auth/signup`,
    {
      email: email.trim().toLowerCase(),
      password,
      name: name.trim(),
      role,
      preferred_language,
      turnstile_token: turnstile_token || undefined,
    },
    withSkipGlobalError()
  );
  return res.data;
}

export async function resetPassword(token, password) {
  const res = await axios.post(`${API}/auth/reset-password`, { token, password });
  return res.data;
}

export async function requestMagicLink(email) {
  const res = await axios.post(`${API}/auth/magic-link`, {
    email: email.trim().toLowerCase(),
  });
  return res.data;
}

export async function consumeMagicLink(token) {
  const res = await axios.post(`${API}/auth/magic-link/consume`, { token });
  return res.data;
}

export async function resendVerification(email) {
  const res = await axios.post(
    `${API}/auth/resend-verification`,
    { email: email.trim().toLowerCase() },
    withSkipGlobalError()
  );
  return res.data;
}

export async function verifyEmailToken(token) {
  const res = await axios.get(`${API}/auth/verify`, { params: { token } });
  return res.data;
}

export async function logoutSession(token) {
  const res = await axios.post(`${API}/auth/logout`, {}, { headers: authHeaders(token) });
  return res.data;
}

export async function changePassword(token, currentPassword, password) {
  const res = await axios.post(
    `${API}/auth/change-password`,
    { current_password: currentPassword, password },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function deleteAccount(token, password) {
  const res = await axios.post(
    `${API}/auth/delete-account`,
    { password },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function contactAcharya({ message, email, userId, token }) {
  const res = await axios.post(
    `${API}/contact/acharya`,
    { message, email, user_id: userId },
    { headers: authHeaders(token) }
  );
  return res.data;
}
